export const replaceComplaintMergeField = (text: string, regionName: string): string =>
  text.replace(/\{complaint\}/g, regionName);
